import { MediaManagerApiBase } from '../MediaManagerApiBase';
export class SdkApi extends MediaManagerApiBase {
  constructor(mediaManagerSDK) {
    super();
    this.mediaManagerSDK = mediaManagerSDK;
  }
  async listItems(folderId, params) {
    const {
      data,
      paging
    } = await this.mediaManagerSDK.listItemsMP(folderId, params);
    return {
      data,
      paging
    };
  }
}
//# sourceMappingURL=SdkApi.js.map